<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card class="pa-3">
            <v-card-title v-if="dialog">
                <h2 class="title">Import Views to Digital Issue {{ item.issue }}</h2>
            </v-card-title>

            <v-card-text class="mt-5">
                <div>
                    <div class="px-2">
                        <v-file-input
                            id="image"
                            accept=".csv"
                            ref="file" 
                            show-size 
                            label="CSV"
                            placeholder="Please Select"
                            v-model="preparedData.file"
                            :error-messages="errors($v.preparedData.file) || server_errors.file"
                            @change="handleFileUploads"
                        ></v-file-input>
                    </div>
                    <v-alert class="pa-2 mt-6" :value="$v.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
                        <span class="caption">Please fill out form correctly</span>
                    </v-alert>
                    <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert"
                             transition="scale-transition">
                        <span class="caption">{{ serverValidationMessage }}</span>
                    </v-alert>
                </div>
            </v-card-text>

            <v-card-actions class="px-6">
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
                <v-btn
                    color="primary"
                    :disabled="loading"
                    :loading="loading"
                    @click="ImportViews"
                >Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import ApiService from "@/common/api.service"
    import { validationMixin } from "vuelidate"
    import { required } from "vuelidate/lib/validators"
    import { valMessages, getValMessage } from "@/common/error-messages"

    let validations = {
        preparedData: {
            file: { required }
        }
    };

    export default {
        name: 'ImportViewsToDigitalIssue',
        mixins: [validationMixin],
        validations,
        data: () => ({
            no_data: [null, "", undefined, "null"],
            item: null,
            loading: false,
            dialog: false,
            preparedData: {},
            file: null,
            serverValidation: true,
            serverValidationMessage: "Oops something went wrong...",
            server_errors: {}
        }),
        mounted() {
            this.$root.$on('ImportViewsToDigitalIssue', this.openModal)
        },
        beforeDestroy() {
            this.$root.$off('ImportViewsToDigitalIssue', this.openModal)
        },
        methods: {
            openModal(item) {
                this.item = item
                this.file = null
                this.preparedData = {}
                this.$v.$reset()
                this.resetServerValidation()
                this.loading = false
                this.dialog = true
            },
            ImportViews() {
                this.resetServerValidation()
                this.$v.preparedData.$touch();
                if (!this.$v.preparedData.$invalid) {
                    this.loading = true
                    let body = {
                        issue_id: this.item.id,
                        file: this.file
                    }
                    ApiService.post('/admin/digital_issue/import_views', body)
                        .then(response => {
                            this.$root.$emit("notification", {
                                status: "success",
                                text: 'Views have been successfully imported.'
                            });
                            this.loading = false
                            this.$emit('done')
                            this.closeModal()
                        })
                        .catch(({response}) => {
                            this.loading = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            if (response.data.message) {
                                this.serverValidationMessage = response.data.message;
                            }
                            if (response.data.errors) {
                                this.server_errors = response.data.errors;
                            }
                        });
                }
            },
            closeModal() {
                this.dialog = false
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, " "));
            },
            handleFileUploads(event) {
                if(event) {
                    let file = event;

                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = e => {
                        this.file = e.target.result
                    }
                } else {
                    this.file = null,
                    delete this.preparedData.file
                }
            },
            resetServerValidation() {
                this.serverValidation = true;
                this.serverValidationMessage = "Oops something went wrong...";
                this.server_errors = {};
            },
            errors: getValMessage(valMessages)(validations)
        }
    }
</script>
